export default "__VITE_ASSET__c677b29d__"